import { STATUS_FINANCEIRO_LABELS, STATUS_FINANCEIRO_VALUES } from "@/modules/obras";
import { periodoDaObraNoWizard } from "../hooks/nova-obra.equipe";
import { useMemo, useState } from "react";
import {
  useObraEmbarcacaoInformacoes,
  useObraEmbarcacoes,
  useObraLocais,
  useObraStatusCriacao,
} from "@/modules/obras";
import { useNovaObra } from "../hooks/nova-obra.context";

const statusFinanceiroOptions = STATUS_FINANCEIRO_VALUES.map((value) => ({
  value,
  label: STATUS_FINANCEIRO_LABELS[value],
}));

export function useEtapaObra() {
  const {
    state,
    errosVisiveis,
    hasDadosDependentesDaEmbarcacao,
    atualizarObra,
    alternarManutencaoCorretiva,
    trocarEmbarcacao,
  } = useNovaObra();
  const { obra } = state;

  const [verLimites, setVerLimites] = useState(false);
  const [pendingEmbarcacao, setPendingEmbarcacao] = useState<string | null | undefined>(undefined);

  const embarcacoes = useObraEmbarcacoes();
  const locais = useObraLocais();
  const statusObra = useObraStatusCriacao();
  const informacoes = useObraEmbarcacaoInformacoes(obra.embarcacaoId);

  const embarcacaoOptions = useMemo(
    () => embarcacoes.data.map(({ id, nome }) => ({ value: id, label: nome })),
    [embarcacoes.data],
  );
  const localOptions = useMemo(
    () =>
      locais.data.map(({ id, codigo, nome }) => ({
        value: id,
        label: codigo ? `${codigo} - ${nome}` : nome,
      })),
    [locais.data],
  );
  const statusOptions = useMemo(
    () => statusObra.data.map(({ id, descricao }) => ({ value: id, label: descricao })),
    [statusObra.data],
  );

  const handleEmbarcacaoChange = (value: string | null) => {
    if (value === obra.embarcacaoId) return;

    // RN03: trocar com Tipos de Obra preenchidos perde dados → confirma antes de efetivar.
    if (obra.embarcacaoId && hasDadosDependentesDaEmbarcacao) {
      setPendingEmbarcacao(value);
      return;
    }
    trocarEmbarcacao(value);
  };

  const confirmarTroca = () => {
    if (pendingEmbarcacao !== undefined) trocarEmbarcacao(pendingEmbarcacao);
    setPendingEmbarcacao(undefined);
  };

  const cancelarTroca = () => setPendingEmbarcacao(undefined);
  const abrirLimites = () => setVerLimites(true);
  const fecharLimites = () => setVerLimites(false);

  const consultaComFalha = [embarcacoes, locais, statusObra].find(
    (consulta) => consulta.status === "forbidden" || consulta.status === "error",
  );

  const financeiroDesabilitado = !obra.manutencaoCorretiva;

  return {
    state,
    errosVisiveis,
    atualizarObra,
    alternarManutencaoCorretiva,
    obra,
    verLimites,
    abrirLimites,
    fecharLimites,
    confirmandoTroca: pendingEmbarcacao !== undefined,
    cancelarTroca,
    informacoes,
    embarcacaoOptions,
    localOptions,
    statusOptions,
    handleEmbarcacaoChange,
    confirmarTroca,
    consultaComFalha,
    financeiroDesabilitado,
    statusFinanceiroOptions,
    periodoObra: periodoDaObraNoWizard(state.etapas.duracao),
  };
}
